module.exports = __webpack_public_path__ + "static/media/bike-pin.bfeed31d.svg";